import React from "react";
import { PauseIcon, PlayIcon, RotateCcwIcon } from "lucide-react";
import { usePitchTimer } from "../../hooks/usePitchTimer";
const PITCH_SECONDS = 5 * 60;
export function PitchTimer() {
  const {
    remaining,
    running,
    start,
    pause,
    reset
  } = usePitchTimer(PITCH_SECONDS);
  const mm = String(Math.floor(remaining / 60)).padStart(1, "0");
  const ss = String(remaining % 60).padStart(2, "0");
  const low = remaining <= 30;
  return <div className="flex items-center justify-between gap-4" data-id="element-91" data-mp="18x81nxm8o6qp">
      <p className={`text-5xl font-bold tabular-nums tracking-tight ${remaining === 0 ? "text-danger" : low ? "text-saffron-ink" : ""}`} aria-live="off" data-id="element-92" data-mp="1dw2iwv4k5n8p">
        {mm}:{ss}
      </p>
      <div className="flex gap-2" data-id="element-93" data-mp="1457v3mbnyfl5">
        <button type="button" onClick={running ? pause : start} disabled={remaining === 0} aria-label={running ? "Pause timer" : "Start timer"} className="flex h-11 w-11 items-center justify-center rounded-full bg-ink text-white transition-[transform,background-color] duration-150 hover:bg-ink/85 active:scale-[0.95] disabled:bg-ink/30" data-id="element-94" data-mp="14457bn9n0t9g">
          {running ? <PauseIcon className="h-5 w-5" data-id="element-95" data-mp="1wetdt3nfyvov" /> : <PlayIcon className="h-5 w-5" data-id="element-96" data-mp="2a8ue41u1kqrc" />}
        </button>
        <button type="button" onClick={reset} aria-label="Reset timer" className="flex h-11 w-11 items-center justify-center rounded-full border border-line bg-surface text-ink transition-colors duration-150 hover:bg-paper" data-id="element-97" data-mp="2aaf91sk9qbpq">
          <RotateCcwIcon className="h-4 w-4" data-id="element-98" data-mp="2f6m5muqryav0" />
        </button>
      </div>
    </div>;
}